<kendo-daterange>
  <kendo-dateinput class="range-filter dateWidth"
                   kendoDateRangeStartInput
                   [value]="start"
                   (valueChange)="filterRange($event, end)"
                   format="MM/dd/yyyy"
                   [formatPlaceholder]="{year: 'YYYY', month: 'MM', day: 'DD'}"
                   style="width:100px">
  </kendo-dateinput>
  -
  <kendo-dateinput class="range-filter dateWidth"
                   kendoDateRangeEndInput
                   [value]="end"
                   (valueChange)="filterRange(start, $event)"
                   format="MM/dd/yyyy"
                   [formatPlaceholder]="{year: 'YYYY', month: 'MM', day: 'DD'}"
                   style="width:100px">
  </kendo-dateinput>
</kendo-daterange>
<button *ngIf="hasFilter"
        class="k-button k-button-icon"
        title="Clear"
        (click)="clearFilter()">
  <span class="k-icon k-i-filter-clear"></span>
</button>
